import Vue from 'vue';
import Vuex from 'vuex';
import { getUser } from '@/api';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userInfo: {},
    moreTitle: '',
  },
  getters: {
    userInfo: (state) => state.userInfo,
    moreTitle: (state) => state.moreTitle,
  },
  mutations: {
    SET_USER_INFO(state, data) {
      state.userInfo = data;
    },
    SET_MORE_TITLE(state, data) {
      state.moreTitle = data;
    },
    SUBTRACT_COIN(state, num) {
      if (state.userInfo && state.userInfo.coin > 0) {
        state.userInfo.coin -= num;
      }
    },
    UPDATE_COIN(state, num) {
      state.userInfo.coin = num;
    },
    UPDATE_MESSAGE_LIMIT(state, num) {
      state.userInfo.message_limit = num;
    },
  },
  actions: {
    async setUserInfo({ commit }) {
      try {
        const res = await getUser();
        const info = res?.data || {};
        commit('SET_USER_INFO', info);
      } catch (error) {
        console.log(error);
      }
    },

    subtractCoin({ commit }, num) {
      commit('SUBTRACT_COIN', num);
    },
    setMoreTitle({ commit }, title) {
      commit('SET_MORE_TITLE', title);
    },
    updateCoin({ commit }, num) {
      commit('UPDATE_COIN', num);
    },
    updateMessageLimit({ commit }, num) {
      commit('UPDATE_MESSAGE_LIMIT', num);
    },
  },
});
